<div class="tool-content-container">
  <div class="tool-description">
    To generate information about financial aid, start by selecting year,
    student type, fund sources and lastly fund types. After submitting the form,
    the result will display 3 charts which are Student Types Amount, Fund
    Sources Amount, and Fund Types Amount.
  </div>

  <progress-bar *ngIf="dataPending"></progress-bar>

  <div
    class="chartjs-container"
    *ngIf="studentTypeFundDataset"
    [class.mat-elevation-z8]="true"
  >
    <div class="chartjs-title">
      <p>Student Types Amount</p>
    </div>
    <canvas id="student-type-fund-amount-chart">{{
      studentTypeFundAmountChart
    }}</canvas>
  </div>

  <div
    class="chartjs-container"
    *ngIf="fundSourcesDataset"
    [class.mat-elevation-z8]="true"
  >
    <div class="chartjs-title">
      <p>Fund Sources Amount</p>
    </div>
    <canvas id="fund-sources-amount-chart">{{ fundSourcesAmountChart }}</canvas>
  </div>

  <div
    class="chartjs-container"
    *ngIf="fundSourcesDataset"
    [class.mat-elevation-z8]="true"
  >
    <div class="chartjs-title">
      <p>Fund Types Amount</p>
    </div>
    <canvas id="fund-types-amount-chart">{{ fundTypesAmountChart }}</canvas>
  </div>
</div>
